import {
	Directive,
  HostListener,
  ElementRef
} from '@angular/core';
import { CurrencyPipe } from '@app/pipes/currency.pipe';

@Directive({
    selector: '[currencyDirective]',
    providers: [CurrencyPipe],
    standalone: false
})
export class CurrencyDirective {
  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private currencyPipe: CurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    if(this.el.value){
      this.el.value = this.currencyPipe.transform(this.el.value);
    }    
  }
}
